import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RepresentativeController } from 'infraestructure/controllers/representativeController'
import { Query } from 'domain/models/query'
import { Status } from 'domain/models/apiResponse'
import {
  Institution,
  ReadInstitutionsByRepresentativeQueryResponse,
} from 'domain/entities/representative'
import {
  getInstitutionsByRepresentativeError,
  getInstitutionsByRepresentativeStart,
  getInstitutionsByRepresentativeSuccess,
  representativeState,
  selectedRepresentativeInstitution,
} from 'presentation/redux/slices/representativeSlice'
import useError from 'presentation/hooks/useError'

export const useGetInstitutionsByRepresentative = () => {
  const dispatch = useDispatch()
  const { isLoading, error, selectedInstitution } = useSelector(representativeState)
  const { getErrorMessage } = useError()

  const getInstitutionsByRepresentative = useCallback(
    async (query?: Query) => {
      dispatch(getInstitutionsByRepresentativeStart())
      try {
        const response = await RepresentativeController.getInstitutionsByRepresentative(query)
        if (response?.status === Status.success) {
          const data = response.data as ReadInstitutionsByRepresentativeQueryResponse
          const institutions = data.entities as Institution[]
          dispatch(getInstitutionsByRepresentativeSuccess(institutions))
          if (selectedInstitution?.institutionId) {
            dispatch(selectedRepresentativeInstitution(selectedInstitution))
          } else {
            dispatch(selectedRepresentativeInstitution(institutions[0]))
          }
        }
      } catch (err) {
        dispatch(getInstitutionsByRepresentativeError(getErrorMessage({ error: err })))
      }
    },
    [dispatch, getErrorMessage, selectedInstitution?.institutionId],
  )

  return { getInstitutionsByRepresentative, isLoading, error }
}
